var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTipperTruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 686 277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "TIPPER TRUCK"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "TIPPER TRUCK"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Group 107",
    transform: "translate(-12.5 -12.786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.4 183.3v-24.5",
    "data-name": "Line 89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.6 183.3h145.9v4.7a6.018 6.018 0 0 0 6 6h7.5",
    "data-name": "Path 137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.8 183.3h22",
    "data-name": "Line 90"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    "data-name": "Ellipse 43",
    transform: "translate(482.9 169.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    "data-name": "Ellipse 44",
    transform: "translate(281.2 169.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    "data-name": "Ellipse 45",
    transform: "translate(218.8 169.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    "data-name": "Ellipse 46",
    transform: "translate(493 179.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    "data-name": "Ellipse 47",
    transform: "translate(291.3 179.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    "data-name": "Ellipse 48",
    transform: "translate(228.9 179.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.1 110.1h-33.4a6.7 6.7 0 0 0-6.7 6.7v13.5a6.7 6.7 0 0 0 6.7 6.7h49.2",
    "data-name": "Path 138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.8 196.4h20",
    "data-name": "Line 91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.4 183.3h-16.3a3.308 3.308 0 0 1-1.9-6l16.6-11.8h250.6V86.8a6.7 6.7 0 0 1 6.7-6.7h51.5a6.8 6.8 0 0 1 5.8 3.3l31.2 53a12.494 12.494 0 0 1 1.8 6.5v45.6a6.7 6.7 0 0 1-6.7 6.7h-33.6",
    "data-name": "Path 139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.5 16.2-172 117.4a15.083 15.083 0 0 0-3.7 21l10.6 15.1 184.4-126a4.853 4.853 0 0 0 1.2-6.8l-13.6-19.4a4.906 4.906 0 0 0-6.9-1.3Z",
    "data-name": "Path 140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.9 165.6-32.5-57.2",
    "data-name": "Line 92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.4 104.3 34.8 61.3",
    "data-name": "Line 93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.1 65.4-23.7-7.1-3.4 9.6-11.7-4.8v12.8h-12.1l-5.7 13.2-15.7-3.1-6 9.7-12.9 2.5-5.5 16-12.6 3.5-3.7 11.9 7.3 10.1",
    "data-name": "Path 141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.1 144.5h-12.4l-5.9 7.6-14.7 6.7 11.4 12.2h15.6l3.7-10.1 10.5 1.6",
    "data-name": "Path 142"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(268.862 243.976)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(-192 -58.9)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(-202.7 -49.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(-183.5 -45.9)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(-176.8 -56.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(-162.3 -61.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(-176 -69.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(-164.6 -47.9)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(-148.9 -50.6)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.445 159.276c5.7.9 8.1 7.8 13 10.8 2.4 1.5 5.4 2 7.8 3.5 3 1.9 4.9 5.1 7.6 7.3 3.5 2.8 8.3 3.9 11 7.5 2 2.7 2.4 6.3 2.4 9.7 0 2-1 5.1-3.9 6.1a119.318 119.318 0 0 1-38.7 8c-15.9.5-31.2-5-38.1-8a6.721 6.721 0 0 1-4.2-6.4 17.991 17.991 0 0 1 7-13.7c1.7-1.3 3.7-2.3 5.4-3.8 2.4-2.1 3.9-5.1 6.6-6.9s6.3-2.1 9.1-3.9c2.6-1.6 4.3-4.3 6.5-6.5s5.4-4.2 8.5-3.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 111"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 110"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M172.4 226.014h375",
    "data-name": "Line 94"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 108"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m173.7 230.414-7.7-4.4 7.7-4.5Z",
    "data-name": "Path 143"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 109"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m546.1 230.414 7.7-4.4-7.7-4.5Z",
    "data-name": "Path 144"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 115"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 114"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M32.2 226.014h96.7",
    "data-name": "Line 95"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 112"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m33.5 230.414-7.8-4.4 7.8-4.5Z",
    "data-name": "Path 145"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 113"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m127.6 230.414 7.8-4.4-7.8-4.5Z",
    "data-name": "Path 146"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 119"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 118"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M4.5 32.214v165.9",
    "data-name": "Line 96"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 116"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m0 33.514 4.5-7.7 4.5 7.7Z",
    "data-name": "Path 147"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 117"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m0 196.814 4.5 7.7 4.5-7.7Z",
    "data-name": "Path 148"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 123"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 122"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m581.5 211.814 28.4-29.2",
    "data-name": "Line 97"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 120"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m585.6 214.014-8.7 2.4 2.3-8.7Z",
    "data-name": "Path 149"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 121"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m612.2 186.614 2.2-8.6-8.6 2.4Z",
    "data-name": "Path 150"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 167"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 162"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 145",
    transform: "translate(-1111 -6299.373)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    fill: "var(--delivery-measurement-color)",
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-measurement-color)",
    d: "M76.861 236.12a2 2 0 0 1 3.4 0l6.914 11.194a2 2 0 0 1-1.7 3.051H71.647a2 2 0 0 1-1.7-3.051Z",
    "data-name": "Polygon 6"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "T,T m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(52.561 267.627)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "T,T m"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 163"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 145",
    transform: "translate(-852.532 -6299.373)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    fill: "var(--delivery-measurement-color)",
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-measurement-color)",
    d: "M335.329 236.12a2 2 0 0 1 3.4 0l6.914 11.194a2 2 0 0 1-1.7 3.051h-13.828a2 2 0 0 1-1.7-3.051Z",
    "data-name": "Polygon 6"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "L,L m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(310.029 267.627)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "L,L m")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 164"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "var(--delivery-measurement-color)",
    "data-name": "Group 124",
    transform: "translate(-1125.959 -6494.267)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 33,
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6541)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.798 6556.71a2 2 0 0 1 2.204-.8l20.574 5.853a2 2 0 0 1 .132 3.806l-32.568 11.848a2 2 0 0 1-2.344-3Z",
    "data-name": "Polygon 2"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "H,H m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(33.708 69.496)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "H,H m"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 165"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "var(--delivery-measurement-color)",
    "data-name": "Group 125",
    transform: "translate(-544.806 -6333.715)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.814 6547.788a2 2 0 0 1 .802 2.204l-5.854 20.574a2 2 0 0 1-3.806.132l-11.848-32.568a2 2 0 0 1 3-2.344Z",
    "data-name": "Polygon 2"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "W,W m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(611.194 233.285)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "W,W m"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipperTruck);
export default __webpack_public_path__ + "static/media/TipperTruck.62ba698b0d0377458e701c0b2f680918.svg";
export { ForwardRef as ReactComponent };